import { Button, Flex } from "monday-ui-react-core";
import { Add } from "monday-ui-react-core/dist/allIcons";
import styled from "styled-components";

import iconCpp from "@/assets/icons/icon-cpp.png";

const WelcomeScreen = styled.div`
  font-family: var(--font-family);
  height: calc(100vh - 140px);
  max-height: 840px;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 320px;
  padding: 16px;
`;

const WelcomeBox = styled.div`
  box-sizing: border-box;
  border-radius: 40px 16px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.1), 0px 8px 16px rgba(0, 0, 0, 0.05);
  background-color: var(--secondary-background-color);
  padding: 28px 32px;
  margin-bottom: 40px;
  img {
    width: 100px;
    height: 100px;
  }
  button {
    margin-left: auto;
    margin-right: 0;
    margin-top: 10px;
  }
`;

const WelcomeMessage = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  margin-top: 12px;
  h1 {
    margin-bottom: 8px;
    font-weight: 300;
  }
  p {
    margin: 5px 0;
    font-size: 16px;
    line-height: 24px;
  }
`;

interface Props {
  onStartCloning: () => void;
}

export function WelcomePage({ onStartCloning }: Props) {
  return (
    <WelcomeScreen>
      <WelcomeBox>
        <Flex>
          <img src={iconCpp} alt="Clone Plus Logo" />
          <WelcomeMessage>
            <h1>
              Welcome to <strong>Clone Plus</strong>
            </h1>
            <p>
              Easily clone a single or multiple items available on a board.
              <br />
              Do you want to clone items?
            </p>
            <Button kind={Button.kinds.PRIMARY} size={Button.sizes.SMALL} leftIcon={Add} onClick={onStartCloning}>
              Start Cloning
            </Button>
          </WelcomeMessage>
        </Flex>
      </WelcomeBox>
    </WelcomeScreen>
  );
}
